(function () {
  'use strict';

  angular
    .module('betosyswebapp')
    .controller('MainController', MainController);

  /* @ngInject */
  function MainController($state, AuthenticationService, dataContainerService, messageService) {
    var vm = this;
    var credentials = AuthenticationService.getCredentials();

    vm.modules = {
        'sref': 'betotrack.dashboard',
        'name': 'track',
        'img': 'assets/images/betocon_small.jpg'
      };


    active();
    openModule(vm.modules);
    ////////////////
    function active() {
      if (credentials) {
        AuthenticationService.logout();

        dataContainerService.cleanAllCache();
        messageService.deInitialize();
      }
    }

    function openModule (module) {
      if (credentials) {
        AuthenticationService.Login(credentials.loginID, credentials.password).finally(function(){
          $state.go(module.sref, {reload: true});
        });
      } else {
        $state.go(module.sref, {reload: true});
      }
    }
  }
})();




// WEBPACK FOOTER //
// ./.tmp/components/home/homeController.js